import { render, staticRenderFns } from "./ScreeningDocumentBatchCreate.vue?vue&type=template&id=3a9dbe54"
import script from "./ScreeningDocumentBatchCreate.vue?vue&type=script&lang=ts"
export * from "./ScreeningDocumentBatchCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports